import { getJurisdictionPack } from "../domain";
import type { MatterDraft, TranscriptRow } from "./ui-types";

export interface PreviewPage {
  readonly page: number;
  readonly rows: TranscriptRow[];
}

/**
 * Screen pagination. Rows are grouped into pages using the jurisdiction
 * pack's print layout (characters per line, lines per page), so previews
 * read as the document they will become. It is an estimate: authoritative
 * page and line numbers are computed when a version is frozen.
 */
export function previewPageGroups(
  rows: TranscriptRow[],
  jurisdictionPack: MatterDraft["jurisdictionPack"]
): PreviewPage[] {
  const layout = getJurisdictionPack(jurisdictionPack).layout;
  const pages: { page: number; rows: TranscriptRow[] }[] = [];
  let current: TranscriptRow[] = [];
  let linesUsed = 0;
  for (const row of rows) {
    const rowLines =
      Math.max(1, Math.ceil(row.text.length / layout.maxCharactersPerLine)) + 1;
    if (linesUsed + rowLines > layout.linesPerPage && current.length > 0) {
      pages.push({ page: pages.length + 1, rows: current });
      current = [];
      linesUsed = 0;
    }
    current.push(row);
    linesUsed += rowLines;
  }
  if (current.length > 0) pages.push({ page: pages.length + 1, rows: current });
  return pages.length > 0 ? pages : [{ page: 1, rows: [] as TranscriptRow[] }];
}
